import type { PropsWithChildren } from "react";

export const FormPage = ({ children }: PropsWithChildren) => {
  return <div className="space-y-9 max-w-2xl">{children}</div>;
};
